<template>
  <div data-component="Widget/DatePickerInput" class="date-picker-input">
    <label :for="id" class="date-label">{{ value || placeholder }}</label>
    <input 
      type="date" 
      class="date-input" 
      :value="value" 
      :id="id"
      @change="handleChange"
    />
    <i v-if="value" class="ico close" @click="handleReset" />
  </div>
</template>

<script>
export default {
  name: 'DatePickerInput',
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Sélectionner une date'
    }
  },
  emits: ['change', 'reset'],
  methods: {
    handleChange(event) {
      this.$emit('change', event.target.value)
    },
    handleReset() {
      this.$emit('reset')
    }
  }
}
</script>

<style lang="scss" scoped>
/* Styles globaux dans src/assets/styles/components/Widget.scss */
</style>
